/* tslint:disable:max-line-length */
import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges, SimpleChange, ViewChild, ElementRef} from '@angular/core';
import CommonUtils from '../../shared/common.util';
import {AssetService} from '../../shared/asset.service';
import {UserService} from '../../user/user.service';
import * as _ from 'lodash';
import {DPUserService, DPSubscriptionService} from '../../portalv1';
import {BulkInfohashV2ManageService} from './bulk-infohash-v2-manage.service';
import {ToasterService} from 'angular2-toaster';
import {UserDetailsService} from '../../shared/user.details.service';
import {InAppNotificationsService} from '../../notifications/notifications.service';
import {ApiConstants} from '../../shared';
import {DPTitleBatchRequest} from '../../portalv1/model/dp-title-batch-request';
import {GeneralConstants} from '../../shared/general.constants';
import {get, difference} from 'lodash';
import moment = require('moment');
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';
import {TitleRequestsService} from '../../catalogue/title-requests/title-requests.service';
import {DatahealthService} from '../../catalogue/datahealth/datahealth.service';
import {QAService} from '../../catalogue/qa/qa.service';
import {ClipboardService} from 'ngx-clipboard';
import {BulkInfohashV2Service} from '../model/bulk-infohash-v2.service';

declare var jQuery: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'bulk-infohash-grouped-manage',
    templateUrl: 'bulk-infohash-v2-manage.component.html',
    styleUrls: ['bulk-infohash-v2-manage.service.scss']
})
export class BulkInfohashV2ManageComponent {
    @ViewChild('modal', {read: ElementRef}) modal: ElementRef;
    @Input() selectedShow;
    @Input() inputSearchQuery;
    @Input() results_test;
    selectedConfidenceLevel: any;
    selectedPage: any;
    selectedPageSize: any;
    originalData;
    loadingInfohash = true;
    @Output() selectedShowChange = new EventEmitter();
    tabs = ['High', 'Medium', 'Low'];
    selectedTab = 'High';
    editMode = false;
    showComponent = false;
    editLoading = false;
    imdbChanged = [];
    importLoading = false;
    harvestedQARequest;
    rejectMessage = '';
    rejectModalLoading = false;
    genres = null;
    languages = null;
    countries = null;
    titlesToAdd = [];
    private selectAll = false;
    primarySelect = false;
    private results = [];
    private hasMore = false;
    private hasResults = false;

    popup: boolean;
    private categories = ['tv', 'movie', 'others'];


    private page = 1;
    private maxPages = 1;
    private imdb_id = undefined;
    private wikibase_id = undefined;
    private google_search = undefined;
    private totalResults;
    private confidenceBreakdown = [];
    private descriptionToBeShowed: string;
    private viewType: number = 0;
    private viewTypeValue = '0';
    private approvalType: number = 1;
    private approvalTypeValue = '1';
    private currentDate;
    private tagsToBeShowed;
    private currentYear;
    private givenYear;
    private searchQuery: string;
    private redirectPopup: any;
    private torrentPriorityToBeShowed: any;
    private infohashToBeShowed: any;
    private discoveryTimeToBeShowed: any;
    private lastAllocatedTimeToBeShowed: any;
    private titlePriorityTimeToBeShowed: any;
    private lastSearchedTimeToBeShowed: any;
    private updatedTimeToBeShowed: any;
    private torrentAvailableToBeShowed: any;
    private humanVerifiedTimeToBeShowed: any;
    private systemVerifiedTimeToBeShowed: any;
    searchForHygeineTitle: any;
    searchByCategory: any;
    private primaryRedirectTorrentName: any;
    private primaryRedirectParrotId: any;
    private primaryRedirectDispalyName: any;

    private CATALOG_GAP_QUERY_OBJECT = {
        'infohash': '',
        'hygiene_title': '',
        'torrent_name': ''
    };


    private APPROVE_QUERY_OBJECT = {
        'infohash': '',
        'properties': [
            {
                'property': 'human_verified',
                'property_value': true
            }
        ]
    };

    private REJECT_QUERY_OBJECT = {
        'infohash': '',
        'properties': [
            {
                'property': 'parrot_id',
                'property_value': '0'
            },

            {
                'property': 'human_verified',
                'property_value': true
            }
        ]
    };

    private UPDATE_QUERY_OBJECT = {
        'approved_infohashes': '',
        'rejected_infohashes': '',
        'updated_infohashes': ''
    };

    private REDIRECT_QUERY_OBJECT = {
        'infohash': '',
        'redirected_from': '',
        'redirected_to': '',
        'category': ''
    };

    private SEARCH_QUERY_OBJECT = {

        'start_date': '',
        'end_date': '',
        'human_verified': '',
        'system_verified': '',
        'category': '',
        'parrot_only': '',
        'demand_only': ''
    };

    constructor(private infohashService: BulkInfohashV2Service, private clip: ClipboardService, private catalogService: CatalogService, private infohashServiceV2: BulkInfohashV2Service,
                public assetService: AssetService,
                private userService: UserService,
                private userDetailsService: UserDetailsService,
                private dpUserService: DPUserService,
                private catalogManageService: BulkInfohashV2ManageService,
                private notificationService: InAppNotificationsService,
                private toasterService: ToasterService) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedShow) {
            const selectedShow: SimpleChange = changes.selectedShow;
            if (selectedShow.currentValue) {
                if (selectedShow.currentValue.parrot_id) {
                    this.loadingInfohash = false;
                    this.handleSearch();
                    this.showComponent = true;
                } else {
                    this.hideDetails();
                }
            }

        }
    }

    handleSearch() {
        this.results = [];
        this.loadingInfohash = true;
        // tslint:disable-next-line:max-line-length
        console.log(this.inputSearchQuery);
        this.getNonSmartGroupedResults();
    }

    createSearchQuery() {
        const requestQuery = _.cloneDeep(this.SEARCH_QUERY_OBJECT);


        requestQuery.human_verified = this.selectedShow.human_verified;
        requestQuery.system_verified = this.selectedShow.human_verified;
        requestQuery.parrot_only = this.selectedShow.parrot_only;
        requestQuery.demand_only = this.selectedShow.demand_only;
        requestQuery.category = this.selectedShow.category;
        requestQuery.start_date = this.selectedShow.start_date;
        requestQuery.end_date = this.selectedShow.end_date;


        return JSON.stringify(requestQuery);


    }


    handleRedirect(results, $event: string[]) {
        this.selectAll = false;
        let redirectedCategory = $event[0];

        if (redirectedCategory.toLowerCase() === 'tv' || redirectedCategory.toLowerCase() === 'show') {
            redirectedCategory = 'tv';
        } else {
            redirectedCategory = redirectedCategory.toLowerCase();
        }

        const redirectedParrotId = $event[1];
        const redirectedCatalogTitle = $event[2];
        const redirectedReleaseYear = $event[3];
        this.primarySelect = !this.primarySelect;
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.action = 'redirect';
                item.redirected_from = item.parrot_id;
                item.parrot_id = redirectedParrotId;

                item.redirected_from_title = item.title;
                item.title = redirectedCatalogTitle;

                item.redirected_from_relese_year = item.release_year;
                item.release_year = redirectedReleaseYear;

                item.redirected_from_category = item.category;
                item.category = redirectedCategory;
            }
            return item;
        });
    }

    handleUndo(data) {
        this.selectAll = false;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        this.results = this.results.map((item) => {
            if (item.selected && item.action) {
                item.selected = !item.selected;
                item.action = undefined;

                if ( item.redirected_from ) {
                    item.parrot_id = item.redirected_from;
                }
                item.human_verified = false;

                if ( item.redirected_from_title ) {
                    item.title = item.redirected_from_title;
                }

                if ( item.redirected_from_relese_year) {
                    item.release_year = item.redirected_from_relese_year;
                }

                if ( item.redirected_from_category) {
                    item.category = item.redirected_from_category;
                }
            }
            return item;
        });
    }

    infohashDetailsPopUp(event, data) {

        this.popup = event;
        this.infohashToBeShowed = data.infohash;
        this.discoveryTimeToBeShowed = data.discovery_time;
        this.lastAllocatedTimeToBeShowed = data.last_allocated_time;
        this.lastSearchedTimeToBeShowed = data.last_searched_time;
        this.updatedTimeToBeShowed = data.updated_time;
        this.torrentAvailableToBeShowed = data.torrent_available;
        this.humanVerifiedTimeToBeShowed = data.human_verified;
        this.systemVerifiedTimeToBeShowed = data.system_verified;
        this.titlePriorityTimeToBeShowed = data.title_priority;
        this.torrentPriorityToBeShowed = data.torrent_priority;

    }

    editMetadataContent(event, data) {

        if (!data.selected) {
            data.selected = !data.selected;
        }

        this.editMode = !this.editMode;

    }


    handleCatalogGap(data) {
        this.selectAll = false;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.action = 'catalog_gap';
                item.human_verified = true;

                const catalogGapObject = this.createCatalogGapObject(item);

                this.infohashService.addToCatalogGapTable(
                    catalogGapObject,
                ).then((res) => {


                    if (res) {

                        this.toasterService.pop('info', 'Successfully Added to Catalog Gap table');

                    } else {
                        this.toasterService.pop('error', 'Failed to add to catalog gap table');
                    }
                }).catch((err) => {
                    console.error('Failed to add to catalog gap' + err.toString());
                    this.toasterService.pop('error', 'Failed to add to catalog gap table');
                });


            }
            return item;
        });

    }

    createCatalogGapObject(result) {


        const catalogGapObject = _.cloneDeep(this.CATALOG_GAP_QUERY_OBJECT);

        catalogGapObject.infohash = result.infohash;
        catalogGapObject.hygiene_title = result.hygiene_title;
        catalogGapObject.torrent_name = result.torrent_name;
        return JSON.stringify(catalogGapObject);
    }

    redirectPopUp(event, data) {

        this.redirectPopup = event;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        this.primarySelect = true;
        this.searchForHygeineTitle = data.hygiene_title;
        this.searchByCategory = data.category;
        this.primaryRedirectTorrentName = data.torrent_name;
        this.primaryRedirectParrotId = data.parrot_id;
        this.primaryRedirectDispalyName = data.displayName;


    }

    closeRedirectPopUp(event, data) {
        this.redirectPopup = event;
        this.primarySelect = false;
    }

    handleTitleSearchSelect($event: string[]) {
        this.handleRedirect(this.results, $event);
        this.closeRedirectPopUp(false, '');
    }

    changeCategory(data: any, value: any) {
        this.selectAll = false;
        // console.log(data);
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.human_verified = true;
                item.category = value;
                item.action = 'updated';
            }
            return item;
        });
        this.editMode = !this.editMode;
    }

    handleSelectAll() {
        this.selectAll = !this.selectAll;
        this.results = this.results.map((item) => {
            item.selected = this.selectAll;
            return item;
        });
        this.primarySelect = !this.primarySelect;
    }

    handleSelected(data) {
        this.selectAll = false;
        data.selected = !data.selected;
        this.primarySelect = !this.primarySelect;
    }

    handleApprove(data) {
        this.selectAll = false;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        // console.log(data);
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.human_verified = true;
                item.action = 'approved';
            }
            return item;
        });
    }

    handleReject(data) {
        this.selectAll = false;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.human_verified = true;
                item.action = 'rejected';
            }
            return item;
        });

    }

    async getNonSmartGroupedResults() {
        this.infohashService.getSmartGroupedInfohash(
            this.inputSearchQuery, this.selectedShow.parrot_id
        ).then((res) => {

            console.log(res);
            this.results = this.results.concat(res.torrents.map(item => this.infohashService.infohashResultItem(item)));
            this.loadingInfohash = false;
        }).catch((err) => {
            console.error('Failed to get infohash results in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to get infohash results');
            this.loadingInfohash = false;
        });
    }

    isLoading(): boolean {
        return this.editLoading || this.rejectModalLoading || this.importLoading;
    }

    handleUpdateTorrents(result) {
        console.log(result);
        this.loadingInfohash = true;
        const updateObject = this.createUpdateObject(this.results);

        this.infohashService.updateInfohashesh(
            updateObject,
        ).then((res) => {
            if (res) {
                if (this.totalResults > (this.page)) {
                    this.page = this.page;
                    this.hasMore = true;
                } else {
                    this.hasMore = false;
                }

                this.loadingInfohash = false;


                this.handleSearch();

                this.toasterService.pop('info', 'Successfully Updated the Infohashes');

                this.loadingInfohash = false;
            } else {
                console.log(res)
                this.toasterService.pop('error', 'Failed to get infohashes');
                this.loadingInfohash = false;
            }
        }).catch((err) => {
            console.error('Failed to update' + err.toString());
            this.toasterService.pop('error', 'Failed to update');
            this.loadingInfohash = false;
        });


    }


    createUpdateObject(results) {

        const updateObject = [];

        results.map((item) => {

            if (item.action === 'approved') {

                const approvedUpdateObject = _.cloneDeep(this.APPROVE_QUERY_OBJECT);

                approvedUpdateObject.infohash = item.infohash;

                updateObject.push(approvedUpdateObject);

            }

            if (item.action === 'rejected') {
                const rejectedUpdateObject = _.cloneDeep(this.REJECT_QUERY_OBJECT);

                rejectedUpdateObject.infohash = item.infohash;

                updateObject.push(rejectedUpdateObject);

            }

            if ((item.action === 'redirect') || (item.action === 'updated')) {

                const propertiesArray = [];

                propertiesArray.push({
                    'property': 'parrot_id',
                    'property_value': item.parrot_id
                });

                propertiesArray.push({
                    'property': 'category',
                    'property_value': item.category
                });

                propertiesArray.push({
                    'property': 'title',
                    'property_value': item.title
                });

                propertiesArray.push({
                    'property': 'human_verified',
                    'property_value': true
                });

                const finalRedirectObject = {
                    'infohash': item.infohash,
                    'properties':
                    propertiesArray
                };

                updateObject.push(finalRedirectObject);
            }

        });

        console.log(JSON.stringify(updateObject));

        return JSON.stringify(updateObject);

    }

    private createRedirectUpdateObject(item) {
        const redirectObject = _.cloneDeep(this.REDIRECT_QUERY_OBJECT);

        redirectObject.infohash = item.infohash;
        redirectObject.redirected_from = item.redirected_from;
        redirectObject.redirected_to = item.parrot_id;
        redirectObject.category = item.category;

        return redirectObject;

    }

    handleNextPage() {
        this.handleGoToPage(this.page + 1);
    }

    handlePreviousPage() {
        this.handleGoToPage(this.page - 1);
    }

    handleFirstPage() {
        this.handleGoToPage(1);
    }

    handleLastPage() {
        this.handleGoToPage(this.maxPages);
    }

    handleGoToPage(page) {
        this.selectAll = false;
        this.page = page;
        if (this.selectedTab === 'Medium') {
            this.showDetails(this.selectedShow, 'Med', this.page);
        } else {
            this.showDetails(this.selectedShow, this.selectedTab, this.page);
        }
    }

    showDetails(show, confidenceLevel, pageNumber) {
        this.showComponent = true;
        this.selectedShow = show;
        this.selectedShowChange.emit(this.selectedShow);
        this.loadingInfohash = false;
        this.getMetaData(show, confidenceLevel, pageNumber);
    }

    viewImdbId(value) {
        const newWindow = window.open('https://www.imdb.com/title/' + value);
    }

    viewWikibaseId(value) {
        const newWindow = window.open('https://www.wikidata.org/wiki/' + value);
    }

    viewGoogleSearch(value) {
        const newWindow = window.open('https://www.google.com/search?q=' + value);
    }

    async getMetaData(show, confidenceLevel, pageNumber) {

        this.currentDate = new Date().toISOString().slice(0, 10);
        const currentYear = new Date().getFullYear().toString();
        // tslint:disable-next-line:radix
        this.currentYear = parseInt(currentYear);
        try {
            if (this.selectedShow.imdb_id) {
                this.imdb_id = this.selectedShow.imdb_id;
            }
            if (this.selectedShow.wikibase_id) {
                this.wikibase_id = this.selectedShow.wikibase_id;
            }
            if (this.selectedShow.start_date) {
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.original_country + ' ' + this.selectedShow.original_language + ' ' + this.selectedShow.start_date;
            } else if (this.selectedShow.release_year) {
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.original_country + ' ' + this.selectedShow.original_language + ' ' + this.selectedShow.release_year;
            } else {
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.original_country + ' ' + this.selectedShow.original_language;
            }
        } catch (ex) {
            console.error('Fail to get links');
        }
        try {
            // tslint:disable-next-line:radix
            this.givenYear = parseInt(this.selectedShow.release_year);
        } catch (ex) {
            console.error('Fail to parse release year');
        }

        try {
            const value = this.viewType;
            let pageSize = 24;
            if (value === 1) {
                pageSize = 25;
            } else if (value === 2) {
                pageSize = 18;
            } else if (value === 3) {
                pageSize = 25;
            } else if (value === 0) {
                pageSize = 24;
            }

            const parrotID = show.parrot_id;

            this.infohashServiceV2.getSmartGroupedTorrents(
                parrotID
            ).then((res) => {
                // console.log(res);
                // console.log('Length',res.length);
                this.results = [];
                this.confidenceBreakdown = [];
                if (res.results.length > 0) {
                    this.hasResults = true;
                    this.results = this.results.concat(res.results.map(item => this.infohashServiceV2.mapIndividualVideoResultItem(item, parrotID)));
                } else {
                    this.hasResults = false;
                }
                this.confidenceBreakdown = res.confidence_breakdown.map(item => this.infohashServiceV2.mapIndividualConfidenceBreakdown(item));
                this.confidenceBreakdown = this.parseConfidenceBreakdown(this.confidenceBreakdown);
                this.totalResults = res.page_info.maxpage;
                if (this.totalResults > (this.page)) {
                    this.hasMore = true;
                } else {
                    this.hasMore = false;
                }
                this.loadingInfohash = true;

            }).catch((err) => {
                this.loadingInfohash = true;
                console.error('Failed to get infohash results in the catalog API' + err.toString());
                this.toasterService.pop('error', 'Failed to get infohash results');
            });

            this.originalData = jQuery.extend(true, {}, this.results);
            this.selectedShowChange.emit(this.results);
        } catch (error) {
            this.loadingInfohash = true;
            // this.errorHandler(error);
        }
        ;
    }

    private parseConfidenceBreakdown(confidenceBreakdown) {

        let lowCount = 0;
        let lowApprovedCount = 0;
        let lowRejectedCount = 0;
        let lowPendingCount = 0;
        let highCount = 0;
        let highApprovedCount = 0;
        let highRejectedCount = 0;
        let highPendingCount = 0;
        let medCount = 0;
        let medApprovedCount = 0;
        let medRejectedCount = 0;
        let medPendingCount = 0;

        for (const value of confidenceBreakdown) {

            if (value.confidence_level === 'UNKNOWN' || value.confidence_level === 'LOW') {
                lowCount = lowCount + value.total_count;
                lowApprovedCount = lowApprovedCount + value.total_approved;
                lowRejectedCount = lowRejectedCount + value.total_rejected;
                lowPendingCount = lowPendingCount + value.total_pending;

            }
            if (value.confidence_level === 'VHIGH' || value.confidence_level === 'HIGH') {
                highCount = highCount + value.total_count;
                highApprovedCount = highApprovedCount + value.total_approved;
                highRejectedCount = highRejectedCount + value.total_rejected;
                highPendingCount = highPendingCount + value.total_pending;

            }
            if (value.confidence_level === 'MED') {
                medCount = medCount + value.total_count;
                medApprovedCount = medApprovedCount + value.total_approved;
                medRejectedCount = medRejectedCount + value.total_rejected;
                medPendingCount = medPendingCount + value.total_pending;
            }

            confidenceBreakdown = [
                {
                    'confidence_level': 'LOW',
                    'total_count': lowCount,
                    'total_approved': lowApprovedCount,
                    'total_rejected': lowRejectedCount,
                    'total_pending': lowPendingCount
                },
                {
                    'confidence_level': 'HIGH',
                    'total_count': highCount,
                    'total_approved': highApprovedCount,
                    'total_rejected': highRejectedCount,
                    'total_pending': highPendingCount
                },
                {
                    'confidence_level': 'MED',
                    'total_count': medCount,
                    'total_approved': medApprovedCount,
                    'total_rejected': medRejectedCount,
                    'total_pending': medPendingCount
                }
            ];
        }

        return confidenceBreakdown;
    }

    selectTab(tab) {
        this.selectedTab = tab;
        this.selectedConfidenceLevel = tab;
        this.page = 1;
        if (tab === 'Medium') {
            this.selectedConfidenceLevel = 'Med';
        }

        this.showDetails(this.selectedShow, this.selectedConfidenceLevel, this.page);
    }

    hideDetails() {
        this.showComponent = false;
    }

    handleApproveAll() {
        this.selectAll = false;

        this.results = this.results.map((item) => {
            item.human_verified = true;
            item.action = 'approved';
            return item;
        });
    }

    handleRejectAll() {
        this.results = this.results.map((item) => {
            item.human_verified = true;
            item.action = 'rejected';
            return item;
        });

    }

    handleClearAll() {
       this.handleSearch();
    }

    descriptionPopUp(event: boolean, description: string, tags: any) {

        this.popup = event;
        this.descriptionToBeShowed = description;
        this.tagsToBeShowed = tags;

    }

    onViewTypeChange(value: number) {
        this.viewType = value;

        if (value === 1) {
            this.viewTypeValue = '1';
        } else if (value === 2) {
            this.viewTypeValue = '2';
        } else if (value === 3) {
            this.viewTypeValue = '3';
        } else if (value === 0) {
            this.viewTypeValue = '0';
        }
    }

    onApprovalTypeChange(value: number) {
        this.approvalType = value;

        if (value === 1) {
            this.approvalTypeValue = '1';
        } else if (value === 2) {
            this.approvalTypeValue = '2';
        } else if (value === 3) {
            this.approvalTypeValue = '3';
        } else if (value === 0) {
            this.approvalTypeValue = '0';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bulkinfohash-v2/bulk-infohash-v2-manage/bulk-infohash-v2-manage.component.ts